import { call, put, select } from 'redux-saga/effects';

import { setOrganizationDetails } from '../../effects/organization';
import { callAPI, METHODS } from '../api';
import { RESOURCES } from '../../../helpers/constants';

export default function* getOrganizationDetails() {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.ORGA}/${organizationId}`;
  try {
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.GET,
    });
    if (result.organizationProvisioningStatus !== undefined) {
      result.unprovisioned =
        !result.organizationProvisioningStatus.startsWith('SUCCESS');
    }
    if (success && !error) {
      yield put(setOrganizationDetails({ ...result, loaded: true }));
    } else {
      yield put(setOrganizationDetails({ error: true, loaded: true }));
    }
  } catch (e) {
    console.error(e);
    yield put(setOrganizationDetails({ error: true, loaded: true }));
  }
}
